import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { Trans } from 'react-i18next';
import { Url } from '@wix/da-url';
import UserLink from '../../User/Link/UserLink';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import HiddenLayout from './HiddenLayout';
import Hidden from './Icons/Hidden';
import { BiData } from '@wix/da-bi/pkg/events';
import hiddenStyles from './Hidden.scss';
const AntisocialBlockedOverlay = (_param)=>{
    var { deviation: { author }, deviation } = _param, props = _object_without_properties(_param, [
        "deviation",
        "deviation"
    ]);
    return /*#__PURE__*/ React.createElement(HiddenLayout, _object_spread({
        icon: /*#__PURE__*/ React.createElement(Hidden, null),
        text: [
            /* prettier-ignore */ author && /*#__PURE__*/ React.createElement(Trans, {
                key: "antisocial",
                i18nKey: "deviationview.blocked.antisocial"
            }, /*#__PURE__*/ React.createElement(UserLink, {
                user: author,
                className: hiddenStyles['link']
            }), " has limited the viewing of this artwork to members of the DeviantArt community only."),
            /* prettier-ignore */ /*#__PURE__*/ React.createElement(Trans, {
                key: "antisocial-cta",
                i18nKey: "deviationview.blocked.antisocial.loginOrJoin"
            }, "You can", ' ', /*#__PURE__*/ React.createElement("a", {
                href: Url.loginLink(),
                className: hiddenStyles['link']
            }, "log in"), ' ', "or", ' ', /*#__PURE__*/ React.createElement(BiLink, {
                href: Url.joinLink(),
                className: hiddenStyles['link'],
                biData: BiData({
                    evid: 240,
                    referral_info: ReferralType.ANTISOCIAL
                })
            }, "become a member"), ' ', "for FREE.")
        ],
        deviation: deviation
    }, props));
};
AntisocialBlockedOverlay.displayName = 'AntisocialBlockedOverlay';
export default AntisocialBlockedOverlay;

//# sourceMappingURL=AntisocialBlocked.js.map